import React from 'react';

import MaxiPlayerPosterV2 from 'components/widgets/Player/components/MaxiPlayerPosterV2/MaxiPlayerPosterV2';
import { useLoadingPerformanceEvents } from 'hooks';
import { createSkeletonCollection } from 'utils';

import { COMPONENT_NAME } from '../../constans';
import VideoContent from '../VideoContent/VideoContent';
import { useVideoPlayoutContext } from '../VideoPlayoutProvider/VideoPlayoutProvider';

import styles from './VideoPlayoutResolveRendering.module.scss';

const SKELETON_ITEMS_NUMBER = 3;
const SCAFFOLD_SKELETON_ITEMS_PREFIX = 'scaffold-skeleton';

function VideoPlayoutResolveRendering({ pageReferenceId }: { pageReferenceId: string }) {
  const { asset, loaded, isContentRestricted, isContentGeoBlocking } = useVideoPlayoutContext();
  const isPlayerCanBeShowed = asset && loaded;
  const isContentGeoBlocked = isContentGeoBlocking || isContentRestricted;
  const scaffolds = createSkeletonCollection(SKELETON_ITEMS_NUMBER, SCAFFOLD_SKELETON_ITEMS_PREFIX);

  useLoadingPerformanceEvents(COMPONENT_NAME, !isPlayerCanBeShowed);

  return (
    <>
      {!isContentGeoBlocked && <MaxiPlayerPosterV2 pageReferenceId={pageReferenceId} />}
      {isPlayerCanBeShowed ? (
        <VideoContent isContentGeoBlocked={isContentGeoBlocked} />
      ) : (
        <div className={styles.scaffold}>
          {scaffolds.map((scaffold) => (
            <div key={scaffold.id} className={styles.scaffoldItem} />
          ))}
        </div>
      )}
    </>
  );
}

export default VideoPlayoutResolveRendering;
